<script>
import baseEdit from '@/views/components/base/baseEdit.vue'
export default {
  extends: baseEdit,
  components: {},
  data() {
    return {
      mname: 'commondescr',
      key: 'id',
      url: {
        get: '/admin/system/common',
        add: '/admin/system/common',
        edit: '/admin/system/common',
      },
      id: "",
      typeId: "",
      items: [
        {
          label: "",
          name: "",
          value: "",
          type: "kong",
        },
        { label: '基本信息', desc: '表单的基本信息', type: 'header' },
        // {
        //   label: '报修/维修',
        //   name: 'workType',
        //   value: 1,
        //   type: 'select',
        //   width: '400px',
        //   dropList: [
        //     { value: 1, name: '报修内容' },
        //     { value: 2, name: '维修内容' },
        //     { value: 3, name: '故障原因' },
        //   ],
        //   rules: [{ required: true, trigger: 'blur', type: 'number' }],
        //   onChange: this.onChangetypes,
        // },
        {
          label: "工单类型",
          name: "workTypeId",
          value: "",
          type: "select",
          width: "400px",
          dropList: [],
          rules: [
            {
              required: true,
              message: "工单类型不能为空",
              trigger: "blur",
              type: "number",
            },
          ],
        },
        { label: '问题描述', name: 'descr', value: '', type: 'input', width: '400px', rules: [{ required: true, trigger: 'blur' }] },

        // { label: '推荐方案', name: 'recommendation', value: '', type: 'textarea', width: '400px' },
        {
          label: "文件",
          name: "accessory",
          value: "",
          type: "documents",
          desc: "",
          handleRemove: this.handleRemove,
        },
        { label: "详情", name: "recommendation", value: "", type: "editor" },
      ],
      forms: {
        workType: 1
      },
    }
  },
  created() {
    this.loadworkData()
    let query = this.$route.query;
    if (query.action == 'edit') {
      this.id = query.kv
      this.handleSearch()

    }
  },
  methods: {
    async handleSearch() {
      let res = await $utils.api.load(`/admin/system/common/${this.id}`)
      try {
        if (res) {
          this.forms = res.data
        }
      } catch (e) {
        console.log(e)
      }
    },

    onChangetypes(val) {
      if (val == 1) {
        this.items[this.getItemIndex("workTypeId")].type = "select";
        this.items[this.getItemIndex("recommendation")].type = "textarea";
      } else {
        this.items[this.getItemIndex("workTypeId")].type = "kong";
        this.items[this.getItemIndex("workTypeId")].value = 0;
        this.items[this.getItemIndex("recommendation")].type = "kong";
        this.items[this.getItemIndex("recommendation")].value = "";
      }
    },
    handleRemove(val) {
    },
    //选择故障类型下拉框
    async loadworkData() {
      let q = {};
      let res = await $utils.api.load(`/admin/system/facility/workTypeHome`, q);
      if (res && res.rows) {
        let list = res.rows;
        if (list.length > 0) {
          let lists = [];
          list.forEach((obj) => {
            lists.push({ name: obj.name, id: obj.id });
            if (obj.deskList && obj.deskList.length > 0) {
              obj.deskList.forEach((item) => {
                const newObj = {
                  name: `${obj.name}-${item.name}`,
                  id: item.id,
                };
                lists.push(newObj);
              });
            }
          });
          let dropList = [];
          for (let index = 0; index < lists.length; index++) {
            const element = lists[index];
            let xx = {};
            xx.value = element.id;
            xx.name = element.name;
            dropList.push(xx);
          }
          for (let index = 0; index < this.items.length; index++) {
            const element = this.items[index];
            if (element && element.name == "workTypeId") {
              this.items[index]["dropList"] = dropList;
            }
          }
        }
      }
    },
    handleSubmit() {
      let q = this.forms

      this.$refs.form.validate((valid) => {
        this.sloading = true;
        $utils.api
          .load(
            `/admin/system/common`,
            q,
            this.action == "edit" ? "PUT" : "POST"
          )
          .then((res) => {
            this.sloading = false;
            if (res.status) {
              $utils.toast.success("保存成功");
              $utils.url.go(-1);
            }
          })
          .catch((e) => {
            this.sloading = false;
            $utils.toast.error("保存异常" + e.message);
          });
      });
    },
  },
}
</script>
